// extracted by mini-css-extract-plugin
module.exports = {"rewardBox":"NextGoal_rewardBox__3Ip1i","text":"NextGoal_text__OpdiB","btn":"NextGoal_btn__1BFeg"};